export function NotFoundView() {
  return (
    <div className="flex h-dvh flex-1 flex-col items-center justify-center gap-y-1">
      <h2 className="text-2xl font-bold">404 | Not Found</h2>
    </div>
  )
}
